import { FC } from 'react'
import { reactStringReplace, sanitizeUrl, useStores } from '@/utils'
import { IQuestionBase, MessageType } from '@/types'
import { observer } from 'mobx-react'
import { EditAndDeleteButtons } from '@/components/atoms/EditAndDeleteButtons'
import router from 'next/router'
import { URL_PATTERN } from '@/constants'
import styles from './index.module.scss'
import { QuestionBoxQuestionerGroup } from '../QuestionBoxQuestionerGroup'

type Props = {
  question: IQuestionBase
}

export const QuestionBox: FC<Props> = observer(({ question }) => {
  const { ui, messages, viewer } = useStores()
  const haveEditAndDelete = question.questioner.username === viewer.viewer?.username

  const toggleModal = () => {
    if (!ui.isForumModalOpen) {
      ui.toggleForumModal()
    }
  }

  const onClickDelete = async (id: string) => {
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure to delete this post?')) {
      const isSuccessful = await viewer.viewer.removeMyQuestion(id)
      if (isSuccessful) {
        messages.add({
          type: MessageType.Info,
          body: 'Your post deleted.',
          isTranslated: true,
          ttl: 5000,
        })
      }
      router.push('/')
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <div className={styles.category}>#{question?.questionCategory.name}</div>
        {haveEditAndDelete && (
          <EditAndDeleteButtons
            onClickEdit={() => {
              toggleModal()
            }}
            onClickDelete={() => onClickDelete(question.id)}
          />
        )}
      </div>
      <p className={styles.title}>{question?.title}</p>
      <p className={styles.body}>
        {reactStringReplace(question?.body, URL_PATTERN, (match, i) => (
          <a key={i} href={sanitizeUrl(match)} target='_blank' rel='noreferrer'>
            {match}
          </a>
        ))}
      </p>
      <QuestionBoxQuestionerGroup question={question} />
    </div>
  )
})
